/*
    The purpose of this code is to create a renderer for avatars in a web application.
    The avatar renderer is responsible for rendering a given avatar onto a canvas at
    a specified location, with a specified scale.
*/
import type { Frame } from "./Animator";
import type { Avatar } from "./Avatar";
import { AvatarCanvas } from "./AvatarCanvas";
import type { Point, Rect } from "./Types";

import * as ColorUtils from "./ColorUtils";

export class AvatarRenderer {
    static drawAvatar(
        avCanvas: AvatarCanvas,
        av: Avatar,
        frame: Frame,
        location: Point,
        scale = 1
    ) {
        const sprite = av.sprite;
        if (!sprite.isReady || !sprite.sheet || !avCanvas) return;

        // Draw the sprite image at the calculated position
        avCanvas.drawFrame(
            sprite.sheet,
            {
                x: frame.col * sprite.size.width,
                y: frame.row * sprite.size.height,
                width: sprite.size.width,
                height: sprite.size.height,
            } as Rect,
            {
                x: location.x - (sprite.size.width * scale) / 2,
                y: location.y,
            } as Point,
            scale
        );

        // If no username is given, return;
        if (!av.username) return;

        avCanvas.font = `${av.font.size}px ${av.font.name}`;
        const textSize = avCanvas.measureText(av.username);

        if (!textSize) return;

        // if the user is using a banner
        if (av.bannerImg) {
            avCanvas.drawBanner(
                av.bannerImg,
                {
                    x: 0,
                    y: 0,
                    width: av.banner.dimensions?.width ?? 32, //textSize.width + 10,
                    height: av.banner.dimensions?.height ?? 32,
                },
                { x: location.x, y: location.y + av.nameOffset * scale + 5 },
                textSize.width,
                av.banner.edgeWidth ?? { left: 2, right: 2 },
                av.banner.padding ?? { left: 0, right: 0 },
                1
            );
        } else {
            if (av.banner.colorMap)
                avCanvas.fillStyle = `${ColorUtils.clampHex(
                    av.banner.colorMap[0]
                )}C0`;
            else avCanvas.fillStyle = "#000000C0";
            avCanvas.fillRoundedRect(
                {
                    x: location.x,
                    y: location.y + av.nameOffset * scale + 5,
                    width: textSize.width + 10,
                    height: 26,
                },
                5,
                true
            );
        }

        avCanvas.fillStyle = av.font.color;
        avCanvas.fillText(
            av.username,
            { x: location.x, y: location.y + av.nameOffset * scale + 10 },
            null,
            true
        );
    }
}
